import { Box } from '@material-ui/core'
import styled from 'styled-components/macro'
import { summitPalette } from './components/summitPalette'
import { ReactComponent as clock } from 'icons/clock.svg'
import { ReactComponent as video } from 'icons/video.svg'
import { css } from 'styled-components'
import './styles.css'
import { Button } from 'common/atoms/Button/Button'

export const StyledButton = styled(Button)`
  && {
    background-color: ${summitPalette.ButtonColor};
    &:hover {
      background-color: ${summitPalette.ButtonColor};
    }
    &:disabled {
      background-color: ${summitPalette.DisabledColor};
    }
  }
`

export const StyledOutlineButton = styled(Button)`
  && {
    border: 2px solid ${summitPalette.ButtonColor};
  }
`

export const StyledGradientButton = styled(Button) <{ rounded?}>`
  && {
    background: ${summitPalette.greenToYellowGradient};
    &:hover {
      background: ${summitPalette.greenToYellowGradient};
    }
    &:disabled {
      background: ${summitPalette.DisabledColor};
    }
    ${props =>
    props.rounded &&
    css`
        border-radius: 100px;
      `}
  }
`

export const StyledGradientOutlineButton = styled(Button)`
  && {
    background: linear-gradient(${summitPalette.BackgroundColor}, ${summitPalette.BackgroundColor}) padding-box, ${summitPalette.yellowToGreenGradient} border-box;
    border: 3px solid transparent;
    &:disabled {
      background: ${summitPalette.DisabledColor};
    }
  }
`

export const StyledClock = styled(clock)`
  && {
    fill: ${summitPalette.IconColor}
  }
`
export const StyledVideo = styled(video)`
  && {
    fill: ${summitPalette.IconColor}
  }
`
export const StyledDay = styled.span`
font-weight: bold;
`

export const StyledHeaderBox = styled(Box)`
  font-family: 'Montserrat', sans-serif;
  font-size: 40px;
  font-weight: 800;
  line-height: 49px;
  background: ${summitPalette.pinkToPurpleGradient};
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  text-align: center;
  @media (max-width: ${props => props.theme.breakpoints.medium}) {
    font-size: 25px;
    line-height: 31px;
  }
`

export const StyledSpeakerCardHeader = styled(Box)`
  font-family: 'Poppins', sans-serif;
  font-size: 20px;
  font-weight: 700;
  color: ${summitPalette.FontColor};
`

export const StyledSpeakerSubHeader = styled(Box)`
  font-family: 'Poppins', sans-serif;
  font-size: 11px;
  font-weight: 400;
  color: ${summitPalette.subHeader};

`

export const StyledTypographyBox = styled(Box)`
  font-family: 'Montserrat', sans-serif;
`

export const StyledBoxBlurred = styled(Box)`
  && {
    -webkit-backdrop-filter: blur(55px);
    -moz-backdrop-filter: blur(55px);
    -o-backdrop-filter: blur(55px);
    -ms-backdrop-filter: blur(55px);
    backdrop-filter: blur(55px);
  }
`

export const StyledSpeakerDetailsDescription = styled(Box)`
  && {
    font-family: 'Montserrat', sans-serif;
    font-size: 21px;
    font-weight: 700;
  }
`

export const StyledSpeakerDetailsBox = styled(Box)`
  && {
    font-family: 'Montserrat', sans-serif;
    font-size: 21px;
    font-weight: 400;
    line-height: 26.14px;
  }
`

export const RobotoTypographyBox = styled(Box)`
  && {
    font-family: 'Roboto', sans-serif;
  }
`